<template>
  <Card>
    <CardHeader class="font-semibold">
      {{ t("order.cardTitles.details") }}
    </CardHeader>
    <CardContent>
      <div class="grid gap-3">
        <ul class="grid gap-3">
          <li class="flex items-center justify-between">
            <span class="text-muted-foreground">
              Borówka x <span> {{ quantity }} </span>
            </span>
            <span>
              {{ currencyFormatter.format(blueberryPrice) }}
              {{ t("order.formLabels.priceUnit") }}
            </span>
          </li>
        </ul>
        <ul class="grid gap-3">
          <li class="flex items-center justify-between">
            <span class="text-muted-foreground">{{
              t("order.formLabels.subtotal")
            }}</span>
            <span
              >{{ calculatedPrice }}
              {{ t("order.formLabels.currencyUnit") }}</span
            >
          </li>
          <li class="flex items-center justify-between">
            <span class="text-muted-foreground">{{
              t("order.formLabels.delivery")
            }}</span>
            <span>0,00 {{ t("order.formLabels.currencyUnit") }}</span>
          </li>
          <!-- <li class="flex items-center justify-between">
            <span class="text-muted-foreground">
              {{ t("order.formLabels.tax") }}</span
            >
            <span>0,00 {{ t("order.formLabels.currencyUnit") }}</span>
          </li> -->
          <li class="flex items-center justify-between font-semibold">
            <span class="text-muted-foreground">{{
              t("order.formLabels.total")
            }}</span>
            <span
              >{{ calculatedPrice }}
              {{ t("order.formLabels.currencyUnit") }}</span
            >
          </li>
        </ul>
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardHeader, CardContent } from "../../card";
import { currencyFormatter } from "../../../lib/utils";
import { computed, watch } from "vue";
import { useBlueberry } from "@acme/api";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps<{
  quantity: number;
}>();

const blueberryResponse = useBlueberry().getBlueberry();

const blueberryPrice = computed(() => {
  if (!blueberryResponse.value.success) return 0;
  return blueberryResponse.value.content.price;
});

const emit = defineEmits<{
  (e: "update:price", value: number): void;
}>();

const calculatedPrice = computed(() =>
  currencyFormatter.format(props.quantity * blueberryPrice.value),
);

watch(
  () => calculatedPrice.value,
  () => {
    emit("update:price", props.quantity * blueberryPrice.value);
  },
);
</script>
